import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LeadCard from "./LeadCard.tsx";
import Filters, { applyFilters } from "../Filters.tsx";

const LeadsList = ({ activeId, setActiveId, leads, handleChangeLeadData }) => {
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({
    messageStatus: "all",
    role: "all",
    notification: "all",
    responseType: "all",
    score: [0, 10],
    leadType: "all",
  });
  const [tempFilters, setTempFilters] = useState({
    messageStatus: "all",
    role: "all",
    notification: "all",
    responseType: "all",
    score: [0, 10],
    leadType: "all",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTempFilters({ ...appliedFilters });
  };

  const handleClose = () => {
    setAnchorEl(null);
    setTempFilters({ ...appliedFilters });
  };

  const handleFilterChange = (filterType, value) => {
    setTempFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const handleSave = () => {
    setAppliedFilters({ ...tempFilters });
    setAnchorEl(null);
  };

  const isAnyFilterActive = () => {
    return Object.entries(appliedFilters).some(([key, value]) => {
      if (key === "score") {
        return value[0] !== 0 || value[1] !== 10;
      }
      return value !== "all";
    });
  };

  const filteredLeads = leads.filter((lead) => {
    const nameMatch = lead.name
      .toLowerCase()
      .includes(searchValue.toLowerCase());

    return nameMatch && applyFilters(lead, appliedFilters);
  });

  return (
    <div className="flex flex-col gap-y-5 w-full lg:w-[428px] p-5 rounded-2xl border border-lighterGray bg-lightestGray mh-box-shadow h-[calc(100vh-120px)]">
      <div className="flex justify-between items-center py-2">
        <p className="text-h2 font-semibold text-pureBlack">
          All Conversations
        </p>
      </div>
      <div className="relative transform">
        <i className="fa-solid fa-magnifying-glass text-darkGray absolute top-1/2 left-[16px] -translate-y-1/2"></i>
        <input
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          type="text"
          placeholder="Search"
          className="h-10 w-full pl-11 rounded-3xl text-h3 text-darkGray bg-lightestBlue placeholder:text-h3 placeholder:text-darkGray border border-lightestBlue focus:border focus:border-darkGray outline-none"
        />
        <div className="relative bottom-5">
          <i
            className="fa-solid fa-filter text-darkGray absolute top-1/2 right-[16px] -translate-y-1/2 cursor-pointer"
            onClick={handleFilterClick}
          ></i>
          {isAnyFilterActive() && (
            <div className="absolute right-[14px] top-[-9px] w-2 h-2 bg-[#EF4747] rounded-full"></div>
          )}
          <Filters
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            tempFilters={tempFilters}
            onFilterChange={handleFilterChange}
            onSave={handleSave}
          />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="flex flex-col gap-y-3">
          {filteredLeads.map((lead) => (
            <LeadCard
              key={lead.id}
              lead={lead}
              activeId={activeId || 1}
              setActiveId={setActiveId}
              handleChangeLeadData={handleChangeLeadData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadsList;
